module.exports = __webpack_public_path__ + "img/mgline.67710772.png";